let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7SKA2")).then(() => parcelRequire('dNA1f'));